const DEFINE = {
    GENERAL: {
        ROLE_ID: {
            ADMIN: "00000000-0000-0000-0000-000000000001",
            STAFF: "00000000-0000-0000-0000-000000000002",
            CUSTOMER: "00000000-0000-0000-0000-000000000003",
            CUSTOMER_SERVICE: "00000000-0000-0000-0000-000000000004",
        },
        CDN_IMG_DEFAULT: "https://",
        // CDN_IMG_DEFAULT: 'http://s3-ap-southeast-1.amazonaws.com/vin-evoucher-static-development/images/',
        ROLE_NAME: {
            "00000000-0000-0000-0000-000000000001": "Quản trị viên",
            "00000000-0000-0000-0000-000000000002": "Nhân viên",
            "00000000-0000-0000-0000-000000000003": "Khách hàng",
            "00000000-0000-0000-0000-000000000004": "Chăm sóc khách hàng",
        },
        VOUCHER_TYPE: {
            PERCENT: "percent",
            GIFT: "gift",
            MONEY: "money"
        },
        PRODUCT_TYPE: {
            VINPEARL_LAND: "00000000-0000-0000-0000-000000000001"
        },
        LOG_VOUCHER_ACTION: {
            1: "Checked",
            2: "Sold",
            3: "Used",
            4: "Locked",
            5: "Unlocked",
            6: 'Refunded',
            7: 'Cancelled',
        },
        ORDER_TYPE_DETAIL: {
            VOUCHER: 1,
            TOUR: 2
        },
        MENU_STAFF: ["/vouchers/check", "/403"],
        PERMISSION: {
            VIEW: "view",
            CREATE: "create",
            UPDATE: "update",
            DELETE: "delete",
            APPROVE: "approve",
            RESEND_EMAIL: "resendEmail",
            EXPORT_VOUCHER: "exportVoucher",
            CHECK_VOUCHER: "checkVoucher",
            SALE_ORDER: "saleOrder",
            USE_VOUCHER: "useVoucher",
            UPDATE_PRICE: 'updatePrice',
            CHECK: 'check',
            EXPORT_FILE_ORDER: 'export',
            EXPORT: 'export',
            VIEW_DETAIL: 'viewDetail',
            UPDATE_ITEM_STATUS: 'updateItemStatus',
            ACCOUNTANT_STATUS : 'updateaccountantstatus',
            LOCK_ITEM: 'lockItem',
            MAP_SKU: 'mapsku',
            REINDEX: 'reindex',
            DEACTIVE: 'deactive',
            SYNC: 'sync',
            UPDATE_STATUS: 'updateStatus',
            BUNDLE_VIEW: "bundleView",
            BUNDLE_CREATE: "bundleCreate",
            BUNDLE_UPDATE: "bundleUpdate",
            RECOMMIT: 'recommit',
            UPDATE_STATUS_BY_EXCEL: 'updateActiveByExcel',
            REDEEM: 'redeem',
            CHANGE_RATECODE: 'changeRateCode',
            RECEIPTS_PAYSLIP_CREATE: 'receiptsPayslipCreate',
            EXPORT_EXCLUDE_USER_INFO: 'exportExcludeUserInfo',
            CONFIRM: 'confirm',
            CANCEL: 'cancel',
            TOPUP: 'topup',
            REFUND: 'refund',
        },
        ROUTE_NAME: {
            TOUR_PROPERTY: 'tourProperties',
            RATEPLAN: 'rateplan',
            HOMESTAY_RATEPLAN: 'homestay-rateplan',
            BOOKABLEPACKAGERATES: 'bookablePackageRate',
            PACKAGERATES: 'packageRate',
            AMENITY: 'amenity',
            SURCHARGES: 'surcharges',
            AIRPORT: 'airport',
            HOME: 'home',
            USER: 'users',
            USER_MANAGEMENT: 'user-management',
            ROLE: 'roles',
            WAREHOUSEMANAGEMENT: 'warehousemanagement',
            POINT_CHANGE_HISTORY: 'creditpoint',
            TOUR: 'tours',
            TAG_GROUP_DETAIL: 'taggroupdetails',
            TOUR_TICKETS: 'tourTickets',
            OBJECT_TYPES: 'objectTypes',
            TICKET_SOLD: 'ticketSold',
            TOUR_MANAGEMENT: 'tour-management',
            PROMOTION_MANAGEMENT: 'promotion',
            PROMOTION_CHECKCODE: 'promotionCheckCode',
            CAMPAIGN: 'campaign',
            AUTO_FILL: 'autofill',
            SUPPLIER: 'suppliers',
            SUPPLIER_PRODUCT: 'supplierproducts',
            RATE_CODE: 'ratecode',
            RATE_COMPARE: 'rateCompare',
            TRANSPORTATION: 'transportation',
            SUPPLIER_CATEGORY: 'category',
            TICKET_MANAGEMENT: 'ticket-management',
            TICKET: 'ticket',
            MY_TICKET: 'myticket',
            TICKET_ASSIGN_CONFIG: 'ticketassign',
            BANNER: 'banners',
            ORDER: 'orders',
            ORDER_DETAIL: 'order-detail',
            ORDER_MANAGEMENT: 'order-management',
            APP: 'appui',
            EMAIL_TEMPLATE: 'email',
            VOUCHER_MANAGEMENT: 'voucher-management',
            PRODUCT: 'products',
            PROPERTY: 'properties',
            GROUP: 'groups',
            AGENT: 'agents',
            BAGGAGE: 'baggage',
            GROUP_CATEGORY: 'voucherCategories',
            VOUCHER: 'vouchers',
            CHECK_VOUCHER: 'checkVoucher',
            HOTEL_MANAGEMENT: 'hotel-management',
            HOTEL: 'hotels',
            HOMESTAY: 'homestays',
            ROOM_TYPE_MANAGEMENT: "room-type-management",
            ROOM_TYPE: "room-types",
            HOMESTAY_ROOM_TYPE: "homestay-room-types",
            LOCATION: "locations",
            CUSTOM_PRICE: 'prices',
            CUSTOM_PRICE_MANAGIMENT: 'price-management',
            POPULAR_PLACE: "popular-places",
            CONTENT_MANAGEMENT: 'content-management',
            WEBSITE: 'websites',
            CATEGORY: 'categories',
            CATEGORY_MANAGEMENT: 'category-management',
            SITEINFO: 'siteInfos',
            SITEINFO_MANAGEMENT: 'siteInfos-management',
            PAGE: 'pages',
            PAGE_MANAGEMENT: 'page-management',
            MENU: 'menu',
            POST: 'posts',
            POST_MANAGEMENT: 'post-management',
            RATING: 'ratings',
            RATING_MANAGEMENT: 'rating-management',
            PRICE_MAKEUP: 'priceMakeup',
            PRICE_MAKEUP_MANAGEMENT: 'priceMakeup-management',
            FLIGHT_MANAGEMENT: 'flight-management',
            FLIGHT_PRICE_CONFIG: 'priceConfigFlight',
            REPORT_MANAGEMENT: 'report-management',
            REPORT: 'reports',
            SALE_REPORT: 'saleReports',
            SALE_REPORT_BY_ORDER: 'saleReportByOrder',
            SALE_REPORT_BY_SKU: 'orderReportBySku',
            VOUCHER_REDEEMTION_REPORT: 'redemptionReports',
            FLIGHT: 'flight',
            CASH_FLOW_REPORT: 'cashflow',
            ORDER_DETAIL_REPORT_BY_SKU: 'orderDetailReportBySku',
            COLLABORATOR_REPORT: 'collaborator',
            ORDER_DETAIL_REPORT_BY_HOTEL: 'orderDetailReportByHotel',
            BUNDLE_REPORT: 'bundleReport',
            BTB_ORDER_REPORT: 'btb-order-report',
            TAG_GROUP_VW: 'taggroupdetails',

            //SYSTEM
            SYSTEM_MANAGEMENT: 'system-management',
            EXCHANGE_RATE: 'exchangeRates',
            FARE_RULES: 'farerule',
            CONFIG_SOURCE_FLIGHT:'config-source-flight',
            VIN_WONDERS: 'vinWonder',
            VIN_WONDER_TICKET: 'vinWonderTicket',
            VIN_WONDER_PRICE: 'vinWonder',
            PRODUCT_FEED: 'productFeed',
            EXPERIENCE: 'experience',
            REDIRECT_LINK: 'redirectlink',
            CONFIG_PHS: 'phs',
            PAY_AT_HOTEL: 'payAtHotel',
            PAY_AT_HOMESTAY: 'payAtHomestay',
            MARKUP_BUNDLE: 'markupBunde',
            RECOMMENDATION: 'recommendation',
            FLIGHT_TRACKING: 'flightTracking',
            BTB_USE_ROOM_REPORT: 'btb-use-room-report',
            CLEAR_CACHE: 'rediscache',

            //GOLF
            VINPEARL_GOLF:"vinpearl-golf",
            GOLF_COURSE:"golf-course",
            GOLF_ADD_ON_SERVICES:"golf-add-on-services",
            GOLF_ADD_ON_SERVICES_CATEGORY:"golf-add-on-services-category",
            GOLF_SPECIAL_OFFERS:"golf-special-offers",
            GOLF_ORDER:"golf-order",
            GOLF_PRODUCT_REVENUE_REPORT:"golf-product-revenue-report",
            GOLF_PROMOTIONS:"golf-promotions",
            GOLF_BOOKING_ACCOUNT:"golf-booking-account",

            //FNB
            FNB:"fnb",
            FNB_OUTLET:"fnboutlet",
            FNB_MENU:"fnbmenu",
            FNB_MENU_ITEM:"fnbmenuitem",
            FNB_PRODUCT:"fnbproduct",
            FNB_PRODUCT_CONDIMENT:"fnbproductcondiment",
            FNB_PRODUCT_OPTION:"fnbproductoption",
            
            
        },
    },
};
export default DEFINE;

export const HOTEL = {
    TYPE: {
        HOTELROOM: 'hotelroom',
        VILLA2BEDROOM: 'villa2bedroom',
        VILLA3BEDROOM: 'villa3bedroom',
        VILLA4BEDROOM: 'villa4bedroom',
        CONDOTEL1BEDROOM: 'condotel1bedroom',
        CONDOTEL2BEDROOM: 'condotel2bedroom',
        NOTSPECIFIED: 'notspecified',
    },
    TYPE_RATE: {
        production: {
            '5e6111a0-964f-4abf-8420-50d6ca0db45b': 'Hotel',
            '6a22a7f1-8f7d-46e4-8d85-58bb90228e29': 'Bundle',
        },
        development: {
            '7882470a-de07-43ee-8fce-9a6903e3098f': 'Hotel',
            '04d60c12-0495-4f9f-ad0b-d20087426ebd': 'Bundle',
        },
        staging: {
            '7882470a-de07-43ee-8fce-9a6903e3098f': 'Hotel',
            '04d60c12-0495-4f9f-ad0b-d20087426ebd': 'Bundle',
        },
        beta: {
            'adc7fa86-4ff5-4258-bce0-6c40dd92b509': 'Hotel',
            'dda016c0-cb33-4669-8b3e-2fd8c7afd126': 'Bundle',
        }
    }
}

export const HOMESTAY = {
    TYPE: {
        HOTELROOM: 'hotelroom',
        VILLA2BEDROOM: 'villa2bedroom',
        VILLA3BEDROOM: 'villa3bedroom',
        VILLA4BEDROOM: 'villa4bedroom',
        CONDOTEL1BEDROOM: 'condotel1bedroom',
        CONDOTEL2BEDROOM: 'condotel2bedroom',
        NOTSPECIFIED: 'notspecified',
    },
    TYPE_RATE: {
        production: {
            '5e6111a0-964f-4abf-8420-50d6ca0db45b': 'Hotel',
            '6a22a7f1-8f7d-46e4-8d85-58bb90228e29': 'Bundle',
        },
        development: {
            '7882470a-de07-43ee-8fce-9a6903e3098f': 'Hotel',
            '04d60c12-0495-4f9f-ad0b-d20087426ebd': 'Bundle',
        },
        staging: {
            '7882470a-de07-43ee-8fce-9a6903e3098f': 'Hotel',
            '04d60c12-0495-4f9f-ad0b-d20087426ebd': 'Bundle',
        },
        beta: {
            'adc7fa86-4ff5-4258-bce0-6c40dd92b509': 'Hotel',
            'dda016c0-cb33-4669-8b3e-2fd8c7afd126': 'Bundle',
        }
    }
}

export const SURCHARGE = {
    TYPE: {
        TICKET: 'ticket',
        ROOM: 'room',
        TICKETREFUNDCANCEL: 'ticketrefundcancel',
        ROOMREFUNDCANCEL: 'roomrefundcancel',
        OTHER: 'other'
    },
    PAYMENT_TYPE: {
        CASH: 'cash',
        TRANSFER: 'transfer',
        QRCode: 'qrcode'
    }
}

export const PAYMENTS_GATEWAY = {
    CASH: 'cash',
    TRANSFER: 'transfer',
    PAYLATER: 'paylater',
    QRCode: 'qrcode',
    PAYATHOTEL: 'pay_at_hotel',
    OTHER: 'other',
    POPR: 'popr'
}

export const PAYMENTS_GATEWAY_SALE_ORDER = {
    CASH: { value: 'cash', isActive: false },
    TRANSFER: { value: 'transfer', isActive: true },
    PAYLATER: { value: 'paylater', isActive: false },
    QRCode: { value: 'qrcode', isActive: false },
    PAYATHOTEL: { value: 'pay_at_hotel', isActive: false },
    OTHER: { value: 'other', isActive: false },
    POPR: { value: 'popr', isActive: true }
}

export const SALE_CHANNELS = {
    ONLINE: 'online',
    CORPORATION: 'corporation',
    CUSTOMER_SERVICE: 'customerservice',
    PROPERTY: 'property',
    INTERNAL: 'internal',
    TRAVEL_AGENT: 'travelagent',
    B2B: 'b2b'
}

export const CHANNELS = {
    ONLINE_WEBSITE: 1,
    ONLINE_APP: 2,
    ONLINE_CHATBOT: 3,
    OFFLINE_WEBSITE: 4,
    BOOKINGVINWONDER: 10,
    APPVINWONDER: 11
}

export const CUSTOM_PRICE = {
    CALCULATE_TYPE: {
        AMOUNT: 'Amount',
        PERCENT: 'Percentage'
    },
}

export const TOUR = {
    OPERATION_TYPE: {
        INBOUND: 1,
        OUTBOUND: 2,
    },
    LENGTHOFTOUR: ['1.0', '2.1', '3.2', '4.3', '5.4', '6.5', '6.4', '7.6', '8.7', '15.14', '22.21'],
    AIRLINE_ENUM: [
        'Vietjet Air',
        'Vietnam Airlines',
        'Bamboo Airways',
        'Korean Air'
    ],
    PRODUCT_TYPES_ENUM: [
        { id: 1, key: 'flightAndHotel' },
        { id: 6, key: 'highSpeedShipHotel' },
        { id: 2, key: 'vinpearlHotel' },
        { id: 3, key: 'tourAndExperience' },
        { id: 4, key: 'airportPickup' },
        { id: 5, key: 'installmentVIN' },
    ],
    CHANNELS: {
        VPT: { id: 1, value: 1, label: 'VPT' },
        AppMVP: { id: 2, value: 2, label: 'App MVP' },
        Chatbot: { id: 3, value: 3, label: 'Chatbot' },
        VinWonders: { id: 10, value: 10, label: 'VinWonders' },
        AppVinwonder: {id: 11, value: 11, label: 'App Vinwonder'}
    },
    TICKET_INFO_ENUM: {
        PROPERTY: {id: 1, value: 1, label: 'Cơ sở'},
        TIME_SLOT: {id: 2, value: 2, label: 'Khung giờ'},
        SEAT : {id: 3, value: 3, label: 'Số ghế'}
    }
}

export const CAMPAIGN = {
    PRODUCT_TYPE: {
        HOTEL: { id: 'HOTEL', value: 'HOTEL', key: 'hotel', label: 'Hotel' },
        SKU: { id: 'SKU', value: 'SKU', key: 'sku', label: 'SKU' },
        FNB: { id: 'FNB', value: 'FNB', key: 'fnb', label: 'FnB' },
        // VOUCHER: { id: 'VOUCHER', value: 'VOUCHER', key: 'voucher', label: 'Voucher' },
        TOUR: { id: 'TOUR', value: 'TOUR', key: 'tour', label: 'SKU' },
        VINWONDER: { id: 'VINWONDER', value: 'VINWONDER', key: 'vinWonder', label: 'Vinwonder' },
    },
    CREATE_TYPE: {
        SKU: { id: 'sku', key: 'sku', label: 'SKU' },
        FNB: { id: 'fnb', key: 'fnb', label: 'FnB' },
        HOTEL: { id: 'hotel', key: 'hotel', label: 'Hotel' },
        MARKUP: { id: 'markup', key: 'markup', label: 'Markup' },
        DIEM: { id: 'diem', key: 'diem', label: 'Điểm'},
    },
    DISCOUNT_TYPE: {
        AMOUNT: { id: 'MONEY', key: 'amount' },
        PERCENT: { id: 'PERCENTAGE', key: 'percent' },
        CHANGE_RATE: { id: 'CHANGE_RATE', key: 'changeRate', hide: true },
    },
    BANK_DISCOUNT_TYPE: {
        AMOUNT: { id: 'MONEY', key: 'amount' },
        PERCENT: { id: 'PERCENTAGE', key: 'percent' },
    },
    PAYMENT_BANK_TYPE: {
        ONEPAY: { id: 'ONEPAY', key: 'onepay' },
        VPT: { id: 'VPT', key: 'vpt' },
    },
    CONTRIBUTION_TYPE: {
        VPT: { id: 1, value: 'VPT', key: 'vpt', label: 'VPT' },
        MARKETING: { id: 2, value: 'MARKETING', key: 'marketing', label: 'MKT HO' },
    },
    PAYMENT_METHOD: {
        ONEPAY: { id: 'ONEPAY', key: 'onepay', label: 'Onepay' },
        NAPAS: { id: 'NAPAS', key: 'napas', label: 'Napas' },
        MOMO: { id: 'MOMO', key: 'momo', label: 'Momo' },
    },
    PROMOTION_TYPE: {
        UNIQUE: { id: 'UNIQUE', key: 'unique' },
        GENERAL: { id: 'GENERAL', key: 'general' },
    },
    OPTION_SKU: {
        ALL: { id: 1, key: 'skuAll' },
        SPECIFIC: { id: 2, key: 'skuSpecific' },
    },
    SCHADULE_TYPE: {
        BOOKING_DATE: { id: 1, key: 'bookingDate' },
        USE_DATE: { id: 2, key: 'useDate' },
    },
    BONUS_TYPE: {
        TRACKING: { id: 1, key: 'tracking', disabled: true },
        DECREACE: { id: 2, key: 'decreace' },
        PRODUCT: { id: 3, key: 'product', disabled: true },
    },
    DECREACE_TYPE: {
        ITEM: { id: 1, key: 'ITEM'},
        ALL: { id: 2, key: 'ALL' }
    },
    NATIONAL: ['VN', 'KO', 'US'],
    SALE_CHANNELS: ['WEB', 'APP', 'OFFLINE'],
    PLATFORMS: {
        WEB_PC: { id: 'WEB_PC', value: 'WEB_PC', key: 'webPc', label: 'Web PC' },
        WEB_MOBILE: { id: 'WEB_MOBILE', value: 'WEB_MOBILE', key: 'webMobile', label: 'Web Mobile' },
    },
    OBJECT_TYPE: {
        ALL: { id: 'ALL', value: 'ALL', key: 'all', label: 'All' },
        MEMBER: { id: 'MEMBER', value: 'MEMBER', key: 'member', label: 'MEMBER' },
        GUEST_VISITING: { id: 'GUEST_VISITING', value: 'GUEST_VISITING', key: 'guestVisiting', label: 'Guest' },
        // SPECIFIC: { id: 'SPECIFIC', value: 'SPECIFIC', key: 'specific', label: 'SPECIFIC' },
        ANOTHER: { id: 'ANOTHER', value: 'ANOTHER', key: 'another', label: 'ANOTHER' },
    },
    OBJECT_TYPE_DATA_EMAIL: {
        SPECIFIC: { id: 'SPECIFIC', value: 'SPECIFIC', key: 'specific', fieldData: 'emails' },
        EMAIL_SUFFIX: { id: 'EMAIL_SUFFIX', value: 'EMAIL_SUFFIX', key: 'emailSuffix', fieldData: 'emailSuffix' },
    },
    USER_FREQUENCY_LIMIT_PERIOD: {
        NONE: { id: null, value: null, key: 'none' },
        DAY: { id: 'DAY', value: 'DAY', key: 'day' },
        WEEK: { id: 'WEEK', value: 'WEEK', key: 'week' },
        MONTH: { id: 'MONTH', value: 'MONTH', key: 'month' },
        CAMPAIGN: { id: 'CAMPAIGN', value: 'CAMPAIGN', key: 'campaign' },
    },
    CODE_TYPE: {
        STANDARD: { id: 'STANDARD', value: 'STANDARD', key: 'standard', label: 'STANDARD', disabledByKey: 'isLoyaltyVoucher' },
        CUSTOMIZE: { id: 'CUSTOMIZE', value: 'CUSTOMIZE', key: 'customize', label: 'CUSTOMIZE', disabledByKey: '' },
    },
    MEMBER_SHIP_TYPE: {
        // GOLD: { id: 'GOLD', value: 'GOLD', key: 'standard', label: 'Gold' },
        // DIAMOND: { id: 'DIAMOND', value: 'DIAMOND', key: 'diamond', label: 'Diamond' },
        // ELITE: { id: 'ELITE', value: 'ELITE', key: 'elite', label: 'Elite' },
        // GUEST: { id: 'GUEST', value: 'GUEST', key: 'guest', label: 'Guest' },
        // PEARL_CLUB: { id: 'PEARL_CLUB', value: 'PEARL_CLUB', key: 'pearl_club', label: 'Peal Club' },
        // TEMP: { id: 'TEMP', value: 'TEMP', key: 'temp', label: 'Temp' },
        NON: { id: 6, value: 6, key: 6, label: 'Non' },
        MEMBER: { id: 9 , value: 9, key: 1, label: 'Member' },
        PEARL: { id: 7, value: 7, key: 7, label: 'Gold (Pearl)' },
        AMBASSADOR_PEARL: { id: 8, value: 8, key: 8, label: 'Platinum (AmPearl)' },
        PEARL_CLUB: { id: 5, value: 5, key: 5, label: 'Diamond (VipPearl)' }
    },
    MEMBER_SHIP_TYPE_TOUR: {
        NON: { id: 6, value: 'NON', key: 6, label: 'Non' },
        MEMBER: { id: 9 , value: 'MEMBER', key: 9, label: 'Member' },
        PEARL: { id: 7, value: 'PEARL', key: 7, label: 'Gold (Pearl)' },
        AMBASSADOR_PEARL: { id: 8, value: 'AMBASSADOR_PEARL', key: 8, label: 'Platinum (AmPearl)' },
        PEARL_CLUB: { id: 5, value: 'PEARL_CLUB', key: 5, label: 'Diamond (VipPearl)' },
    },
    SPECIAL_EVENT: {
        CARD: {id: 1, key: 1, value: 1, label: 'configBenefitCard'},
        VOUCHER: {id: 2, key: 2, value: 2, label: 'configBenefitVoucher'}
    },
    DATE_LIMIT: {
        NONE: { id: 0, key: 'NONE', data: "NONE", value: 0, label: `item.bundle.noDateRestriction` },
        HAS_RESTRICTION: {
            id: 1,
            key: 'HAS_RESTRICTION',
            label: `item.bundle.dateRestriction`,
            subOptions: [
                { key: 'DATE', data: 'DATE', value: 1, label: `item.bundle.dateRestrictionType.byOddDays` },
                { key: 'DATE_RANGE', data: 'DATE_RANGE', value: 2, label: `item.bundle.dateRestrictionType.byDateRange` },
                { key: 'DAY_OF_WEEK', data: 'DAY_OF_WEEK', value: 3, label: `item.bundle.dateRestrictionType.byDayOfWeek` },
            ],
        },
    }
}

export const AUTOFILL_ENUM = {
    MEMBER_SHIP_TYPE: {
        GUEST: { id: 4, value: 4, key: 4, label: 'Guest' },
        NON: { id: 6, value: 6, key: 6, label: 'Non' },
        MEMBER: { id: 9 , value: 9, key: 9, label: 'Member' },
        PEARL: { id: 7, value: 7, key: 7, label: 'Gold (Pearl)' },
        AMBASSADOR_PEARL: { id: 8, value: 8, key: 8, label: 'Platinum (AmPearl)' },
        PEARL_CLUB: { id: 5, value: 5, key: 5, label: 'Diamond (VipPearl)' },
    },
    PRODUCTYPES: {
        HOTEL: { id: 1, value: 1, key: 1, label: 'Hotel'},
        // BUNDLE: { id: 'bundle', value: 'bundle', key: 'bundle', label: 'Bundle'},
        SKU: { id: 6, value: 6, key: 6, label: 'SKU', group: 1},
        APP_MYVP: { id: 'APP_MYVP', value: 'APP_MYVP', key: 'APP_MYVP', label: 'MyVP - Search'},
        APP_VW_PRE_CHECKOUT: { id: 11, value: 11, key: 11, label: 'Vinwonders App'},
        BOOKING_VW_PRE_CHECKOUT: { id: 10, value: 10, key: 10, label: 'Booking Vinwonders'},
        APP_VINWONDERS: { id: 11, value: 11, key: 11, label: 'Vinwonders App'},
        BOOKING_VINWONDER: { id: 10, value: 10, key: 10, label: 'Vinwonders Booking'},
        11: { id: 11, value: 11, key: 11, label: 'Vinwonders App'},
        10: { id: 10, value: 10, key: 10, label: 'Vinwonders Booking'}
    },
    PRODUCTYPES_GROUPBY: {
        BOOKING_VP: {
            HOTEL: { id: 1, value: 1, key: 1, label: 'Hotel', group: 1},
            SKU: { id: 6, value: 6, key: 6, label: 'SKU', group: 1},
        },
        APP_MYVP: {
            APP_MYVP: { id: 'APP_MYVP', value: 'APP_MYVP', key: 'APP_MYVP', label: 'MyVP - Search' },
        },
        BOOKING_VW: {
            BOOKING_VW_PRE_CHECKOUT: { id: 10, value: 10, key: 10, label: 'Vinwonder - Precheckout'}
        },
        APP_VW: {
            APP_VW_PRE_CHECKOUT: { id: 11, value: 11, key: 11, label: 'Vinwonder - Precheckout'},
        }
    }
}

export const RATE_ENUM = {
    VALUE_CANCEL_POLICY: {
        Flat: { id: 0, key: 0, value: 'Flat', label: 'flat' },
        Percent: { id: 1, key: 1, value: 'Percent', label: 'percent' },
    },
}

export const CONFIG_PHS_ENUM = {
    ACTIVE: {
        true: 'turnOn',
        false: 'turnOff',
    },
}

export const INSTALLMENT = {
    INSTALLMENT_FREE: ['CUS', 'VIN'],
    INSTALLMENT_LIMIT: {
        SIX_MONTH: '6',
        TWELVE_MONTH: '12',
        SIX_TWELVE_MONTH: '6.12'
    }
}

export const FLIGHT_STATUS = ['HELD', 'HELD_FAIL', 'ISSUED', 'ISSUE_FAIL']

export const DEFAULT_TOUR_PROPERTY = [
    { label: 'Vouchers', value: 1, sku: true },
    { label: 'Tours', value: 2, sku: true },
    { label: 'VinWonders', value: 7, sku: true },
]

export const ORDER = {
    TYPE_ITEM: {
        1: 'vouchers',
        2: 'tours',
        3: 'flights',
        4: 'hotels',
        5: 'vinWonders'
    },
    TYPES: {
        VOUCHER: { id: 1, color: '#AB37E1', icon: 'faTag', key: 'voucher' },
        TOUR: { id: 2, color: '#E7256B', icon: 'faSuitcaseRolling', key: 'tour' },
        FLIGHT: { id: 3, color: '#F4753F', icon: 'faPlane', key: 'flight' },
        HOTEL: { id: 4, color: '#458CF7', icon: 'faHotel', key: 'hotel' },
        VINWONDER: { id: 5, color: '#F4753F', icon: 'faTicketAlt', key: 'vinWonder' },
        BUNDLE: { id: 6, color: '#E7256B', icon: 'faCity', key: 'bundle' },
        VINWONDER_NEW: { id: 7, color: '#F4753F', icon: 'faTicketAlt', key: 'vinWonderNew' },
        PACKAGERATE: { id: 8, color: '#2269A6', icon: 'faPlusCircle', key: 'packageRate' },
        LINKCROSSSELL: { id: 9, color: '#2269A6', icon: 'faPlusCircle', key: 'linkCrossSell' },
        HOMESTAY: { id: 10, color: '#ED2227', icon: 'faHouseUser', key: 'homestay' },
        GOLF : { id: 11, color: '#00AE41', icon: 'faGolfBall', key: 'vinpearlGolf' },
        FNB : { id: 12, color: '#FF7F50', icon: 'faUtensils', key: 'fnb' },
    },
    ITEMTYPES: {
        VOUCHER: { id: 1, color: '#AB37E1', icon: 'faTag', key: 'voucher' },
        TOUR: { id: 2, color: '#E7256B', icon: 'faSuitcaseRolling', key: 'tour' },
        FLIGHT: { id: 3, color: '#F4753F', icon: 'faPlane', key: 'flight' },
        HOTEL: { id: 4, color: '#458CF7', icon: 'faHotel', key: 'hotel' },
        VINWONDER: { id: 5, color: '#F4753F', icon: 'faTicketAlt', key: 'vinWonder' },
        BUNDLE: { id: 6, color: '#E7256B', icon: 'faCity', key: 'bundle' },
        VINWONDER_NEW: { id: 7, color: '#F4753F', icon: 'faTicketAlt', key: 'vinWonderNew' },
        PACKAGERATE: { id: 8, color: '#2269A6', icon: 'faPlusCircle', key: 'packageRate' },
        LINKCROSSSELL: { id: 9, color: '#2269A6', icon: 'faPlusCircle', key: 'linkCrossSell' },
        HOMESTAY: { id: 10, color: '#ED2227', icon: 'faHouseUser', key: 'homestay' },
        GOLF : { id: 11, color: '#00AE41', icon: 'faGolfBall', key: 'vinpearlGolf' },
        FNB : { id: 12, color: '#FF7F50', icon: 'faUtensils', key: 'fnb' },
    },
    TYPE_ITEM_TOTAL: [
        'vouchers',
        'tours',
        'vinWonders'
    ],
    STATUS: {
        UNPAID: 1,
        WAITING: 4,
        PAID: 2,
    },
    ENUM_STATUS: {
        UNPAID: {
            value: 1,
            showOn: []
        },
        PAID: {
            value: 2,
            showOn: [4, 9]
        },
        // FAILED: 3,
        // PENDING: {
        //     value: 4,
        //     showOn: []
        // },
        PARTIALLYCANCELLED: {
            value: 5,
            showOn: []
        },
        CANCELLED: {
            value: 6,
            showOn: [2, 5, 7, 9]
        },
        PARTIALREFUNDED: {
            value: 7,
            showOn: []
        },
        REFUNDED: {
            value: 8,
            showOn: [2, 5, 7, 9]
        },
        WAITING: {
            value: 9,
            showOn: [2]
        }
    },
    ENUM_PAYMENT_STATUS: {
        UNPAID: {
            value: 1,
            showOn: []
        },
        PAID: {
            value: 2,
            showOn: [4]
        },
        PENDING: {
            value: 4,
            showOn: []
        },
    },
    TOUR_ITEM_STATUS: [1, 2, 3],
    ORDER_ITEM_STATUS: [1, 2, 3, 4, 5, 7, 13],
    ACCEPT_STATUS_ITEM: {
        vinWonders: {
            2: [4, 5]
        },
        vouchers: {
            2: [4, 5],
            3: [4, 5]
        },
        tours: {
            2: [4, 5, 7],
            3: [4, 5, 7]
        },
        flights: {
            2: [4, 5],
            13: [2, 4, 5]
        },
        hotels: {
            2: [4, 5],
            13: [2, 4, 5]
        }
    },
    ORDER_ITEM_STATUS_OBJ: {
        PUBLISHED: 1,
        SOLD: 2,
        USED: 3,
        REFUNDED: 4,
        CANCELLED: 5,
        FAILED: 13,
    },
    PAYMENT_STATUS_OBJ: {
        UNPAID: 1,
        PAID: 2,
        PENDING: 4,
    },
    ORDER_STATUS_OBJ: {
        FAILED: 1,
        SUCCESS: 2,
        PARTIALLY_CANCELLED: 5,
        CANCELLED: 6,
        PARTIALLY_REFUNDED: 7,
        REFUNDED: 8,
        WAITING: 9,
    },
    ENUM_ORDER_STATUS: {
        FAILED: {
            value: 1,
            showOn: [],
        },
        SUCCESS: {
            value: 2,
            showOn: [1, 9],
        },
        WARNING: {
            value: 9,
            showOn: [],
        },
    },
    COLOR_ORDER_STATUS: {
        9: 'orange',
        2: 'green',
        4: 'blue',
        1: 'red'
    },
    COLOR_ORDER_QUICK_TASK_STATUS: {
        1: 'red',
        2: 'green',
    },
    VINWONDER_ITEM_TYPE: {
        SUBMARINE: 4
    },
    MAX_SUBMARINE: 5
}

export const TAGGROUP = {
    TYPES: {
        RATETAG: { id: 7, color: '#E7256B', icon: 'faCity', key: 'rateTag' },
    }
}

export const BANNER = {
    TYPES: {
        HOME: { id: 'home', name: 'Home' },
        VOUCHER: { id: 'voucher', name: 'Voucher' },
        // TOUR: { id: 'tour', name: 'Tour' },
        // FLIGHT: { id: 'flight', name: 'Flight' },
        HOTEL: { id: 'hotel', name: 'Hotel' },
        COMBO: { id: 'combo', name: 'Combo' },
        EXPERIENCE: { id: 'experience', name: 'Experience' },
    },
    IMAGE_IDS: [
        'main_hotel_banner', 'main_voucher_banner', 'main_combo_banner', 'main_home_banner', 'main_experience_banner',
        'hotel_banner_ads', 'combo_banner_ads', 'home_banner_ads',
        'hotel_banner_ads_mobile', 'combo_banner_ads_mobile', 'home_banner_ads_mobile',
        'footer_hotel_banner', 'footer_combo_banner', 'footer_home_banner',
        'footer_hotel_banner_mobile', 'footer_combo_banner_mobile', 'footer_home_banner_mobile',
        'home_sticky_bottom_ads', 'hotel_sticky_bottom_ads', 'combo_sticky_bottom_ads', 'voucher_sticky_bottom_ads', 'experience_sticky_bottom_ads', 'vinwonder_banner_bottom', 'vinwonder_banner_bottom_mobile',
        'home_sticky_bottom_ads_mobile', 'hotel_sticky_bottom_ads_mobile', 'combo_sticky_bottom_ads_mobile', 'voucher_sticky_bottom_ads_mobile', 'experience_sticky_bottom_ads_mobile',
    ]
};

export const VOUCHER = {
    TEMPLATE_FILE_URL: `https://static.vinpearltravel.vn/excel_templates/import-voucher-template.xlsx`,
    STATUS: {
        PUBLIC: { id: 1, key: 'public', color: 'green' },
        SOLD: { id: 2, key: 'sold', color: 'green' },
        USED: { id: 3, key: 'used', color: 'grey' },
        REFUNDED: { id: 4, key: 'refuned', color: 'orange' },
        CANCELLED: { id: 5, key: 'cancelled', color: 'red' },
        FAIL: { id: 13, key: 'fail', color: 'red' },
        LOCKED: { id: 998, key: 'locked', color: 'darkgrey' },
        EXPIRED: { id: 999, key: 'expired', color: 'grey' },
    },
}

export const FLIGHT = {
    PASSENGER: {
        TYPE: {
            ADULT: 'ADT',
            CHILDREN: 'CHD',
            INFANT: 'INF',
        },
        GENDER: {
            MALE: 1,
            FEMALE: 0,
        },
    },
}

export const SUPPLIER = {
    CONTRACT: {
        STATUS: {
            // PROCESSING: { id: 0, key: 'processing', color: 'blue' },
            UNSIGNED: { id: 1, key: 'unsigned', color: 'grey' },
            SIGNED: { id: 2, key: 'signed', color: 'green' },
        },
    },
    PRODUCT: {
        TYPE: {
            VEHICLE: { id: 1, key: 'vehicle' },
            ACCOMMODATION: { id: 2, key: 'accommodation' },
            MEAL: { id: 3, key: 'meal' },
            ACTIVITY: { id: 4, key: 'activity' }
        },
    },
    PRODUCT_SUPPLIER: {
        TYPE: {
            SALE: { id: 1, value: 1, key: 'sale', label: 'sale' },
            ROOT: { id: 2, value: 2, key: 'root', label: 'root' }
        }
    },
    SALE_DATE_TYPE:{
        TYPE:{
            MULTIPLE : { id:1, value:1 , key: 'multipleDate', label: 'Có (Chọn lẻ ngày)', data: 'MULTIPLE'},
            NONE : { id:2, value:2 , key: 'noneDate', label: 'Không', data: 'NONE'},
            RANGE : { id:3, value:3 , key: 'rangeDate', label: 'Có (Chọn khoảng ngày)', data: 'RANGE'},
        }
    }
}

export const MARKUP = {
    CREATE_TYPE: {
        Bundle: { id: 'Bundle', key: 'bundle', label: 'Bundle' },
        Hotel: { id: 'Hotel', key: 'hotel', label: 'Hotel' }
    },
    CAMPAIGN_TYPE: {
        MARKUP_BUNDLE: { id: 'MARKUP_BUNDLE', value: 'MARKUP_BUNDLE', key: 'bundle', label: 'Markup Bundle' },
        MARKUP_HOTEL: { id: 'MARKUP_HOTEL', value: 'MARKUP_HOTEL', key: 'hotel', label: 'Markup Hotel' }
    }
}

export const TICKET = {
    ACTION_TYPE: {
        UNKNOW: { id: 0, key: 'unknow' },
        ASSIGN: { id: 1, key: 'assign' },
        CHANGE_STATUS: { id: 2, key: 'changeStatus' },
    },
    PRIORITY: {
        UNKNOW: { id: 0, key: 'unknow' },
        LOWEST: { id: 1, key: 'lowest' },
        LOW: { id: 2, key: 'low' },
        MEDIUM: { id: 3, key: 'medium' },
        HIGH: { id: 4, key: 'high' },
        HIGHEST: { id: 5, key: 'highest' },
    },
    STATUS: {
        UNKNOW: { id: 0, key: 'unknow', hide: true },
        ACTIVE: { id: 1, key: 'active', color: 'green' },
        PROCESSING: { id: 2, key: 'processing', color: 'blue' },
        HOLD: { id: 3, key: 'hold', color: 'grey' },
        CLOSE: { id: 4, key: 'close', color: 'red', hide: true },
    },
}

export const OBJECT_TYPE = {
    SELECT: {
        SAME_PRICE: { id: '00000000-0000-0000-0000-000000000001', key: 'samePrice' },
        SPECIFIC: { id: 'specific', key: 'specific' },
    },
}

export const OBJECT_RATE_CODE_TYPE = {
    Single: { id: 1, label: 'Một mã giá' },
    Multi: { id: 2, label: 'Nhiều mã giá' },
}

// NCT: Người cao tuổi, NL: Người lớn, TE: Trẻ em
export const OBJECT_TYPE_FOR_VINWONDER7 = ["NCT", "NL", "TE"];

export const RATECODE = {
    GROUP_TYPE: {
        TOUR: { id: 2, value: 2, label: 'Tour'},
        VOUCHER: { id: 1, value: 1, label: 'Voucher'}
    },
    GROUP_TYPE_VINWONDER: {
        VINWONDER: { id: 7, value: 7, label: 'Vinwonder'},
    }
}

export const SUPPLIER_CATEGORY = {
    KEY_TYPE: {
        NUMBER: { id: 0, value: 0, label: 'Number'},
        STRING: { id: 1, value: 1, label: 'String'}
    },
    SUPPLIER_TYPE: {
        VINWONDER: { id: 0, value: 0, label: 'Vinwonder'}
    }
}

export const UPLOAD_DIRECTORY = {
    GENERAL: 'general',
    GROUP_THUMB: 'group_thumb',
    IMAGES: 'images',
    TOUR_THUMB: 'tours',
    HOTEL_THUMBS: 'hotel_thumbs',
    HOTEL: 'hotels',
    HOMESTAY: 'homestays',
    GOLF: 'golf',
    POPULAR_PLACE: 'popularPlaces',
    PAGE: "page_thumb",
    POST: "post_thumb",
    ROOM_TYPES: 'room_types',
    LOCATION: 'locations',
    SUPPLIER: 'suppliers',
    EMAIL_TEMPLATE: 'email',
    VIN_WONDER_THUMB: 'vinwonder_thumb',
    AMENITY: 'hotels/amenity',
    CAMPAIGN_THUMB: 'campaign_thumb',
    APP_UI: 'appui/welcome',
    FNB_OUTLET: 'fnb_outlet',
    FNB_PRODUCT: 'fnb_product',
}

export const UPLOAD = {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    MAX_VIDEO_UPLOAD_SIZE: 100 * 1024 * 1024 // 100MB
}

export const PATHS = {
    ROOT: '/',
    LOGIN: { path: '/login' },
    LOGOUT: { path: '/logout' },
    PROFILE: { path: '/profile' },
    REFRESH: { path: '/refresh' },
    PAGE_403: { path: '/403' },
    USER: {
        path: '/users',
        LIST: { path: '/users/list' },
        CREATE: { path: '/users/action' },
        DETAIL: { path: '/users/action/:id' },
    },
    ROLE: {
        path: '/roles',
        LIST: { path: '/roles/list' },
        CREATE: { path: '/roles/action' },
        DETAIL: { path: '/roles/action/:id' },
    },
    BANNER: {
        path: '/banners',
        LIST: { path: '/banners/list' },
        CREATE: { path: '/banners/action' },
        DETAIL: { path: '/banners/action/:id' },
    },
    HOTEL: {
        path: '/hotels',
        LIST: { path: '/hotels/list' },
        CREATE: { path: '/hotels/action' },
        DETAIL: { path: '/hotels/action/:id' },
    },
    HOMESTAY: {
        path: '/homestays',
        LIST: { path: '/homestays/list' },
        CREATE: { path: '/homestays/action' },
        DETAIL: { path: '/homestays/action/:id' },
    },
    PROMOTION: {
        path: '/promotions',
        LIST: { path: '/promotions/list' },
        CREATE: { path: '/promotions/action' },
        DETAIL: { path: '/promotions/action/:id' },
        CHECK: { path: '/promotions/check' }
    },
    AUTOFILL: {
        path: '/autofill',
        LIST: { path: '/autofill/list' },
        CREATE: { path: '/autofill/action' },
        DETAIL: { path: '/autofill/action/:id' },
    },
    CAMPAIGN: {
        path: '/campaigns',
        LIST: { path: '/campaigns/list' },
        CREATE: { path: '/campaigns/action/create/:type' },
        DETAIL: { path: '/campaigns/action/detail/:id' },
    },
    TOUR_PROPERTIES: {
        path: '/tour-properties',
        LIST: { path: '/tour-properties/list' },
        CREATE: { path: '/tour-properties/action' },
        DETAIL: { path: '/tour-properties/action/:id' },
    },
    TOUR: {
        path: '/tours',
        LIST: { path: '/tours/list' },
        CREATE: { path: '/tours/action' },
        DETAIL: { path: '/tours/action/:id' },
        TICKET: {
            path: '/tours/action/:tour_id/tourtickets',
            CREATE: { path: '/tours/action/:tour_id/tourtickets/action' },
            DETAIL: { path: '/tours/action/:tour_id/tourtickets/action/:id' },
        }
    },
    WAREHOUSEMANAGEMENT: {
        path: '/warehousemanagement',
        LIST: { path: '/warehousemanagement/list'},
        CREATE: { path: '/warehousemanagement/action'},
        DETAIL: { path: '/warehousemanagement/action/:id'},
    },
    POINT_CHANGE_HISTORY: {
        path: '/point-change-history',
        LIST: { path: '/point-change-history/list'}
    },
    GOLF_COURSE: {
        path: '/golf-course',
        LIST: { path: '/golf-course/list'},
        CREATE: { path: '/golf-course/action' },
        DETAIL: { path: '/golf-course/action/:id' },
    },
    GOLF_ADD_ON_SERVICES: {
        path: '/golf-add-on-services',
        LIST: { path: '/golf-add-on-services/list'}
    },
    GOLF_ADD_ON_SERVICES_CATEGORY: {
        path: '/golf-add-on-services-category',
        //LIST: { path: '/golf-add-on-services-category/list'}
    },
    GOLF_SPECIAL_OFFERS: {
        path: '/golf-special-offers',
        //LIST: { path: '/golf-special-offers/list'}
    },
    GOLF_ORDER: {
        path: '/golf-order',
        //LIST: { path: '/golf-order/list'}
    },
    GOLF_PRODUCT_REVENUE_REPORT: {
        path: '/golf-product-revenue-report',
        //LIST: { path: '/golf-product-revenue-report/list'}
    },
    GOLF_PROMOTIONS: {
        path: '/golf-promotions',
        //LIST: { path: '/golf-promotions/list'}
    },
    GOLF_BOOKING_ACCOUNT: {
        path: '/golf-booking-account',
        //LIST: { path: '/golf-booking-account/list'}
    },

    SUPPLIER: {
        path: '/suppliers',
        LIST: { path: '/suppliers/list' },
        CREATE: { path: '/suppliers/action' },
        DETAIL: { path: '/suppliers/action/:id' },
    },
    SUPPLIER_PRODUCT: {
        path: '/supplierproducts',
        LIST: { path: '/supplierproducts/list' },
        CREATE: { path: '/supplierproducts/action' },
        DETAIL: { path: '/supplierproducts/action/:id' },
        USAGE_PLAN : { path: '/supplierproducts/usage-plan/:id' },
    },
    RATECODE: {
        path: '/ratecode',
        LIST: { path: '/ratecode/list' },
        CREATE: { path: '/ratecode/action' },
        DETAIL: { path: '/ratecode/action/:id' },
        USAGE_PLAN: { path: '/ratecode/usage-plan/:id'},
        SCHEDULE: { path: '/ratecode/schedule' }
    },
    SUPPLIER_CATEGORY: {
        path: '/category',
        LIST: { path: '/category/list' },
        CREATE: { path: '/category/action' },
        DETAIL: { path: '/category/action/:id' },
    },
    TOUR_TICKET: {
        path: '/tourtickets',
        LIST: { path: '/tourtickets/list' },
        CREATE: { path: '/tourtickets/action' },
        DETAIL: { path: '/tourtickets/action/:id' },
    },
    OBJECT_TYPES: {
        path: '/object-types',
        LIST: { path: '/object-types/list' },
        CREATE: { path: '/object-types/action' },
        DETAIL: { path: '/object-types/action/:id' },
    },
    TICKET_SOLD: {
        LIST: { path: '/ticket-sold/list/' },
        LIST_FILTERED_CODE: { path: '/ticket-sold/list/:ticket' },
        CREATE: { path: '/ticket-sold/action' },
        DETAIL: { path: '/ticket-sold/action/:id' },
    },
    ROOM_TYPE: {
        path: '/room-types',
        LIST: { path: '/hotels/action/:hotel_id/room-types/list' },
        CREATE: { path: '/hotels/action/:hotel_id/room-types/action' },
        DETAIL: { path: '/hotels/action/:hotel_id/room-types/action/:id' },
    },
    HOMESTAY_ROOM_TYPE: {
        path: '/room-types',
        LIST: { path: '/homestays/action/:homestay_id/room-types/list' },
        CREATE: { path: '/homestays/action/:homestay_id/room-types/action' },
        DETAIL: { path: '/homestays/action/:homestay_id/room-types/action/:id' },
    },
    RATE: {
        path: '/rates',
        LIST: { path: '/hotels/action/:hotel_id/rates/list' },
        CREATE: { path: '/hotels/action/:hotel_id/rates/action' },
        DETAIL: { path: '/hotels/action/:hotel_id/rates/action/:id' },
    },
    HOMESTAY_RATE: {
        path: '/rates',
        LIST: { path: '/homestays/action/:homestay_id/rates/list' },
        CREATE: { path: '/homestays/action/:homestay_id/rates/action' },
        DETAIL: { path: '/homestay/action/:homestay_id/rates/action/:id' },
    },
    RATE_COMPATE: {
        path: '/rate-compate',
        LIST: { path: '/hotels/action/:hotel_id/rate-compare/list' },
        CREATE: { path: '/hotels/action/:hotel_id/rate-compare/action' },
        DETAIL: { path: '/hotels/action/:hotel_id/rate-compare/action/:id' },
    },
    BOOKABLE_PACKAGE_RATE: {
        path: '/bookable-package-rates',
        LIST: { path: '/hotels/action/:hotel_id/bookable-package-rates/list' },
        CREATE: { path: '/hotels/action/:hotel_id/bookable-package-rates/action' },
        DETAIL: { path: '/hotels/action/:hotel_id/bookable-package-rates/action/:id' },
    },
    PACKAGE_RATE: {
        path: '/package-rates',
        LIST: { path: '/package-rates/list' },
        CREATE: { path: '/package-rates/action' },
        DETAIL: { path: '/package-rates/action/:id' },
        VIEW: { path: '/package-rates/view/:id' },
    },
    LOCATION: {
        path: '/locations',
        LIST: { path: '/locations/list' },
        CREATE: { path: '/locations/action' },
        DETAIL: { path: '/locations/action/:id' },
    },
    CUSTOM_PRICE: {
        path: '/prices',
        LIST: { path: '/hotels/action/:hotel_id/prices/list' },
        CREATE: { path: '/hotels/action/:hotel_id/prices/action' },
        DETAIL: { path: '/hotels/action/:hotel_id/prices/action/:id' },
    },
    POPULAR_PLACE: {
        path: '/popular-places',
        LIST: { path: '/popular-places/list' },
        CREATE: { path: '/popular-places/action' },
        DETAIL: { path: '/popular-places/action/:id' },
    },
    CATEGORY: {
        path: '/categories',
        LIST: { path: '/categories/list' },
        CREATE: { path: '/categories/action' },
        DETAIL: { path: '/categories/action/:id' },
    },
    PAGE: {
        path: '/pages',
        LIST: { path: '/pages/list' },
        CREATE: { path: '/pages/action' },
        DETAIL: { path: '/pages/action/:id' },
    },

    POST: {
        path: '/posts',
        LIST: { path: '/posts/list' },
        CREATE: { path: '/posts/action' },
        DETAIL: { path: '/posts/action/:id' },
    },
    RATING: {
        path: '/ratings',
        LIST: { path: '/ratings/list' },
        // CREATE: { path: '/ratings/action' },
        DETAIL: { path: '/ratings/action/:id' },
    },
    SITEINFO: {
        path: '/site-info',
        LIST: { path: '/site-info/list' },
        CREATE: { path: '/site-info/action' },
        DETAIL: { path: '/site-info/action/:id' },
    },
    PRODUCT_FEED: {
        path: '/product-feed',
        EXPORT: { path: '/product-feed/export' },
    },
    PRODUCT_REINDEX: {
        path: '/experience',
        REINDEX: { path: '/experience/reindex' },
    },
    REDIRECT_LINK: {
        path: '/redirect-link',
        LIST: { path: '/redirect-link/list' },
        CREATE: { path: '/redirect-link/action' },
        DETAIL: { path: '/redirect-link/action/:id' },
    },
    CONFIG_PHS: {
        path: '/config-phs',
        DETAIL: { path: '/config-phs/info' },
    },
    AMENITY: {
        path: '/amenity',
        LIST: { path: '/amenity/list' },
        CREATE: { path: '/amenity/action' },
        DETAIL: { path: '/amenity/action/:id' },
    },
    ORDER: {
        path: '/orders',
        LIST: { path: '/orders/list' },
        DETAIL: { path: '/orders/:id' }
    },
    APP: {
        path: '/appui',
        LIST: {path: '/appui/list'},
        CREATE: {path: '/appui/action'},
        DETAIL: {path: '/appui/action/:id'},
        WHITELIST: {path: '/appui/whitelist-ip'}
    },
    EMAIL_TEMPLATE: {
        path: '/email-templates',
        LIST: { path: '/email-templates/list' },
        CREATE: { path: '/email-templates/action' },
        DETAIL: { path: '/email-templates/action/:id' },
    },
    PRICE_MAKEUP: {
        path: '/price-makeup',
        FLIGHT: { path: '/price-makeup/flight', },
    },
    FLIGHTS: {
        path: '/flights',
        PRICE_CONFIG: { path: '/flights/price-config', },
    },
    AIRPORT: {
        path: '/airports',
        LIST: { path: '/airports/list' },
        CREATE: { path: '/airports/action' },
        DETAIL: { path: '/airports/action/:id' },
    },
    FARE_RULES: {
        path: '/farerules',
        LIST: { path: '/farerules/list' },
        CREATE: { path: '/farerules/action' },
        DETAIL: { path: '/farerules/action/:id' },
    },
    CONFIG_SOURCE_FLIGHT:{
        path: '/config-source-flight',
    },
    PRODUCT: {
        path: '/products',
        LIST: { path: '/products/list' },
        CREATE: { path: '/products/action' },
        DETAIL: { path: '/products/action/:id' },
    },
    PROPERTY: {
        path: '/properties',
        LIST: { path: '/properties/list' },
        CREATE: { path: '/properties/action' },
        DETAIL: { path: '/properties/action/:id' },
    },
    GROUP: {
        path: '/groups',
        LIST: { path: '/groups/list' },
        CREATE: { path: '/groups/action' },
        DETAIL: { path: '/groups/action/:id' },
    },
    GROUP_CATEGORY: {
        path: '/group-categories',
        LIST: { path: '/group-categories/list' },
        CREATE: { path: '/group-categories/action' },
        DETAIL: {
            path: '/group-categories/action/:id',
            TRANSLATE: { path: '/group-categories/action/:id/translate', },
        },

    },
    VOUCHER: {
        path: '/vouchers',
        LIST: { path: '/vouchers/list' },
        CREATE: { path: '/vouchers/action' },
        DETAIL: {
            path: '/vouchers/action/:id',
            TRANSLATE: { path: '/vouchers/action/:id/translate/:lang', },
        },
    },
    VIN_WONDER: {
        path: '/vin-wonders',
        LIST: { path: '/vin-wonders/list' },
        CREATE: { path: '/vin-wonders/action' },
        DETAIL: {
            path: '/vin-wonders/action/:id',
            TRANSLATE: { path: '/vin-wonders/action/:id/translate/:lang' },
        },
        CHECK: { path: '/vin-wonders/check' }
    },
    AGENT: {
        path: '/agents',
        LIST: { path: '/agents/list' },
        CREATE: { path: '/agents/action' },
        DETAIL: { path: '/agents/action/:id' },
    },
    BAGGAGE: {
        path: '/baggages',
        LIST: { path: '/baggages/list' },
        CREATE: { path: '/baggages/action' },
        DETAIL: { path: '/baggages/action/:id' },
    },
    REPORT: {
        path: '/reports',
        SALE_REPORT: { path: '/reports/sale-reports' },
        VOUCHER_REDEEMTION_REPORT: { path: '/reports/voucher-redeemtions-reports' },
        SALE_REPORT_BY_ORDER: { path: '/reports/sale-reports-by-order' },
        SALE_REPORT_BY_SKU: { path: '/reports/sale-reports-by-sku' },
        CASH_FLOW_REPORT: {
            path: '/reports/cash-flow-reports/list',
            pathFiltered: '/reports/cash-flow-reports/list/:orderCode',
            CREATE: { path: '/reports/cash-flow-reports/action'}
        },
        ORDER_DETAIL_REPORT_BY_SKU: { path: '/reports/order-detail-reports-by-sku' },
        COLLABORATOR_REPORT: { path: '/reports/collaborator-reports' },
        ORDER_DETAIL_REPORT_BY_HOTEL: { path: '/reports/order-detail-reports-by-hotel' },
        BUNDLE_REPORT: {path: '/reports/bundle-reports'},
        BTB_ORDER_REPORT: { path: '/reports/btb-order-reports' },
        BTB_USE_ROOM_REPORT: { path: '/reports/btb-use-room-reports' },
    },
    TICKET: {
        path: '/tickets',
        LIST: { path: '/tickets/list' },
        CREATE: { path: '/tickets/action' },
        DETAIL: { path: '/tickets/action/:id' },
        MY_TICKET: { path: '/tickets/my-tickets' },
    },
    TICKET_ASSIGN_CONFIG: {
        path: '/ticket-assign-configs',
        LIST: { path: '/ticket-assign-configs/list' },
        CREATE: { path: '/ticket-assign-configs/action' },
        DETAIL: { path: '/ticket-assign-configs/action/:id' },
    },
    SYSTEM: {
        path: '/systems',
        EXCHANGE_RATE: { path: '/systems/exchange-rates' }
    },
    VIN_WONDER_TICKET: {
        path: '/vin-wonder-ticket',
        LIST: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-ticket/list' },
        CREATE: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-ticket/action' },
        DETAIL: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-ticket/action/:id' },
    },
    VIN_WONDER_PRICE: {
        path: '/vin-wonder-prices',
        LIST: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-prices/list' },
        CREATE: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-prices/action' },
        DETAIL: { path: '/vin-wonders/action/:vin_wonder_id/vin-wonder-prices/action/:id' },
    },
    TAG_GROUP_DETAIL: {
        path: '/tag-group-details',
        LIST: { path: '/tag-group-details/list' },
        CREATE: { path: '/tag-group-details/action' },
        DETAIL: {
            path: '/tag-group-details/action/:id',
            LINK_SKU: { path: '/tag-group-details/action/:id/link-skus' },
        },

    },
    TAG_GROUP_VW: {
        path: '/tag-group-vw',
        LIST: { path: '/tag-group-vw/list' },
        CREATE: { path: '/tag-group-vw/action' },
        DETAIL: {
            path: '/tag-group-vw/action/:id',
            LINK_SKU: { path: '/tag-group-vw/action/:id/link-skus' },
        },

    },
    PAY_AT_HOTEL: {
        path: '/pay-at-hotel'
    },
    PAY_AT_HOMESTAY: {
        path: '/pay-at-homestay'
    },
    RECOMMENDATION: {
        path: '/recommendation',
        LIST: { path: '/recommendation/list' },
    },
    MARKUP_BUNDLE: {
        path: '/makeup-bundles',
        LIST: { path: '/makeup-bundles/list' },
        CREATE: { path: '/makeup-bundles/action/:type' },
        DETAIL: { path: '/makeup-bundles/action/:id/:type' },
    },
    CACHE: {
        path: '/caches',
        LIST: { path: '/caches/list' },
        DELETE: { path: '/caches/delete' },
    },
    FNB: {
        path: '/fnb',
        OUTLET: {
            path: '/fnb/outlet',
            LIST: { path: '/fnb/outlet/list' },
            CREATE: { path: '/fnb/outlet/action' },
            DETAIL: { path: '/fnb/outlet/action/:id' },
        },
        OUTLET_MANAGER: {
            path: '/fnb/outlet-manager',
            LIST: { path: '/fnb/outlet-manager/list' },
            CREATE: { path: '/fnb/outlet-manager/action' },
            DETAIL: { path: '/fnb/outlet-manager/action/:id' },
        },
        MENU_MANAGER: {
            path: '/fnb/menu-manager',
            LIST: { path: '/fnb/menu-manager/list' },
            CREATE: { path: '/fnb/menu-manager/action' },
            DETAIL: { path: '/fnb/menu-manager/action/:id' },
            SUB_MENU: {
                path: '/fnb/menu-manager/:id/submenu',
                LIST: { path: '/fnb/menu-manager/:id/submenu/list' },
                DETAIL: { path: '/fnb/menu-manager/:menuId/submenu/action/:id' },
            },
        },
        CONDIMENT_MANAGER: {
            path: '/fnb/condiment-manager',
            LIST: { path: '/fnb/condiment-manager/list' },
            CREATE: { path: '/fnb/condiment-manager/action' },
            DETAIL: { path: '/fnb/condiment-manager/action/:id' },
            SET_MENU: {
                path: '/fnb/condiment-manager/:id/set-menu',
            },
        },
        OPTION_MANAGER: {
            path: '/fnb/option-manager',
            LIST: { path: '/fnb/option-manager/list' },
            CREATE: { path: '/fnb/option-manager/action' },
            DETAIL: { path: '/fnb/option-manager/action/:id' },
            SET_ITEM: {
                path: '/fnb/option-manager/:id/items',
            },
        },
        PRODUCT: {
            path: '/fnb/product',
            LIST: { path: '/fnb/product/list' },
            DETAIL: { path: '/fnb/product/action/:id' },
        },
    },
};

export const CONFIG_LOCAL_STORAGE = {
    PREFIX: 'hms',
    ACCESS_TOKEN: 'utk',
    REFRESH_TOKEN: 'rft',
    EXPIRES: 'expires',
    PROFILE: 'pf',
    AUTHENTICATING: 'authenticating',
    MENU_COLLAPSED: 'menu_collapsed',
    CONTENT_LANGUAGE: 'content_language',
    COLUMN_VISIBLE_CONFIG_PREFIX: 'column_visible_config',
    COLUMN_RESIZE_CONFIG_PREFIX: 'column_resize_config',
};

export const DATE_TIME_FORMAT = {
    MINIMUM_YEAR: 1970,
    SHORT_DATE: 'DD/MM/YYYY',
    SHORT_DATE_EXPORT: 'YYYY-MM-DD',
    DATE_TIME: 'DD/MM/YYYY HH:mm',
    DAY_WEEK_DATETIME: 'dddd, DD/MM/YYYY HH:mm',
    TIME_AND_DATE: 'HH:mm DD/MM/YYYY',
    SHORT_TIME: 'HH:mm',
    FULL_TIME: 'HH:mm:ss',
    SHORT_MONTH: 'MM/YYYY',
    SHORT_DATE_MONTTH: 'DD/MM',
    FULL_DATE_TIME: 'DD/MM/YYYY HH:mm:ss'
}

export const PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
}

export const SAGA_DELAY_TIMEOUT = 300; // delay 300ms on every saga
export const SAGA_DELAY_TIMEOUT_1000 = 1000; // delay 300ms on every saga

export const TOUR_VALIDATE_TAB_FIELDS = {
    GENERAL_INFO: ['tourName', 'tourTypes', 'departure', 'destination', 'lengthOfTour', 'highlight', 'description'],
    DEFAULT_PRICE: ['adultOriginalPrice', 'childOriginalPrice', 'adultSalePrice', 'childSalePrice'],
    TRIP_ITINERARY: ['tripItinerary'],
    NOTED: ['cancellationPolicy'],
    IMAGES: ['thumbImage', 'slideShowImages'],
}
export const TOUR_TABS = {
    TOUR_INFO: {
        id: 'tourInfo',
        key: 'productInfo',
        validateFields: TOUR_VALIDATE_TAB_FIELDS.GENERAL_INFO.concat(
            TOUR_VALIDATE_TAB_FIELDS.DEFAULT_PRICE,
            TOUR_VALIDATE_TAB_FIELDS.TRIP_ITINERARY,
            TOUR_VALIDATE_TAB_FIELDS.NOTED,
            TOUR_VALIDATE_TAB_FIELDS.IMAGES
        ),
        GENERAL_INFO: { id: 'generalInfo', validateFields: TOUR_VALIDATE_TAB_FIELDS.GENERAL_INFO },
        TRIP_ITINERARY: { id: 'tripItinerary', validateFields: TOUR_VALIDATE_TAB_FIELDS.TRIP_ITINERARY },
        DEFAULT_PRICE: { id: 'defaultPrice', validateFields: TOUR_VALIDATE_TAB_FIELDS.DEFAULT_PRICE },
        NOTED: { id: 'noted', validateFields: TOUR_VALIDATE_TAB_FIELDS.NOTED },
        IMAGES: { id: 'images', validateFields: TOUR_VALIDATE_TAB_FIELDS.IMAGES },
    },
    TOUR_TICKET: { id: 'tourTicket', key: 'tourTickets' },
    DEPARTURE_DATE: { id: 'departureDate', key: 'sellPlan' },
};

export const CURRENCY = {
    VND: 'VND',
    USD: 'USD',
    KRW: 'KRW',
}
export const ALL_CURRENCY_ENUM = 'all';

export const COUNTRY_CODE = {
    VN: 'VN',
    US: 'US',
}

export const RECAPTCHA_PAGES = {
    LOGIN: 'login_page',
}

export const VALIDATE_ENUM = {
    MAX_LENGTH: {
        SHORT_DESCRIPTION: 200,
    },
}

export const PRICE_MAKEUP = {
    TYPE: {
        AMOUNT: 1,
        PERCENT: 2,
    },
};

export const PAYMENT_GATEWAY = {
    TYPE: {
        VNPAY: 'vnpay',
        onepay: 'onepay',
        PAY_LATER: 'paylater',
    }
}

export const IMAGE_DIRECTORY_TYPES = {
    THUMB: { id: 0, INCLUDE_DIRECTORIES: [] },
    SLIDE: {
        id: 1, INCLUDE_DIRECTORIES: [
            UPLOAD_DIRECTORY.TOUR_THUMB,
            UPLOAD_DIRECTORY.IMAGES,
            UPLOAD_DIRECTORY.ROOM_TYPES,
        ]
    },
}

export const REFRESH_TOKEN_DELAY_TIMEOUT = (5 * 60 * 1000); // 5 minutes before the access token was expired

export const TRANSLATE_LANGUAGE = {
    VN: { id: 'vi', code: 'vi-VN' },
    EN: { id: 'en', code: 'en-US' },
    KO: { id: 'ko', code: 'ko-KR' },
    ZH: { id: 'zh', code: 'zh-CN' },
    RU: { id: 'ru', code: 'ru-RU' },
    HI: { id: 'hi', code: 'hi-IN' },
}

export const TARGET_LANGUAGE_DATA = [
    {
        label: "Tiếng Anh",
        value: "en-US",
    },
    {
        label: "Tiếng Hàn",
        value: "ko-KR",
    },
    {
        label: "Tiếng Trung",
        value: "zh-CN",
    },
    {
        label: "Tiếng Nga",
        value: "ru-RU",
    },
    {
        label: "Tiếng Ấn",
        value: "hi-IN",
    },
]

export const DEFAULT_LANG_ENUM = 'vi-VN';

export const ALL_LANGUAGE_ENUM = 'all';

export const FEATURE_FLAGS = require('./featureFlags').default;

export const DETAIL_ACTIONS = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    TRANSLATE: 'TRANSLATE',
    CONFIRM: 'CONFIRM',
    VIEW: 'VIEW'
}

export const PROMOTION = {
    BUNDLE_APPLY_TIME: {
        ALL: { id: 1, key: 'all' },
        SOME: { id: 2, key: 'some' },
    }
}

export const WHITE_LIST_DOMAIN = [
    'booking.vinpearl.com',
    'vpt-frontend-website-v2.stg.cloudhms.io',
    'vpt-frontend-website-v2.dev.cloudhms.io'
]

export const LIST_DOMAIN_VPT_ADMIN = {
    dev: 'vpt-frontend-admin-v2.dev.cloudhms.io',
    stg: 'vpt-frontend-admin-v2.stg.cloudhms.io',
    beta: 'vpt-frontend-admin-v2.beta.cloudhms.io',
    prod: 'booking-admin.vinpearl.com',
}

export const LIST_DOMAIN_VPT_WEBSITE = {
    dev: 'https://vpt-frontend-website-v2.dev.cloudhms.io',
    stg: 'https://vpt-frontend-website-v2.stg.cloudhms.io',
    beta: 'https://vpt-frontend-website-v2.beta.cloudhms.io',
    prod: 'https://booking.vinpearl.com',
}

export const DATA_IS_NULL = '0001-01-01T00:00:00'

export const TRANSPORTATIN_OBJECT_TYPE = {
    aduld: { key: 'adult', value: 'numOfAdult' },
    children: { key: 'children', value: 'numOfChild' }
}

export const TRANSPORT_TYPE = [
    'arrival',
    'departure',
    'round-trip',
    'internal_transfer'
]

export const CASH_FLOW_REPORT = {
    TRANSACTION_CODE_TYPE: {
        1000: 'Thanh toán từ onepay',
        1100: 'Thanh toán chuyển khoản',
        1110: 'Thanh toán từ 2c2p',
        1200: 'Thanh toán trả sau',
        1300: 'PO/PR',
        1400: 'Trả góp thông qua onepay',
        1500: 'Phụ thu',
        5000: 'Dư tiền',
        6000: 'Chuyển tiền cơ sở',
        6100: 'Chuyển tiền hãng vé',
        6200: 'Chuyển thanh toán',
        6300: 'Promotion',
        6400: 'Thanh toán tại cơ sở',
        6500: 'Markup',
        6600: 'Làm tròn',
        6800: 'Lãi sản phẩm',
        6900: 'Phí VPT',
        7000: 'Hủy chuyển',
        7100: 'Hủy noshow',
        7200: 'Phí trả góp ngân hàng',
        7400: 'Hủy phụ thu',
        7300: 'Phí trả góp OP',
        7777: 'Tạo phiếu chi',
        8888: 'Tạo phiếu thu',
        7500: 'Hoàn tiền',
        7600: 'Huỷ voucher',
        1900: 'Thanh toán thông qua momo'
    },
    ACTION_TYPE: {
        0: 'Booking',
        1: 'OnlineBooking',
        2: 'IPNFromOnePay',
        3: 'ShopBeforeRedeem',
        4: 'ShopAfterRedeem',
        5: 'CancelProduct',
        6: 'ChangeRateCode',
        7: 'ReceiptVoucher',
        8: 'PaymentVoucher',
        9: 'Redeem',
        10: 'PaymentStatus',
        11: 'Surcharge',
        12: 'SurchargeAfterRedeem',
        13: 'DeleteSurcharge',
        14: 'SaleOrder',
        15: 'RefundVoucher',
        16: 'CancelVoucher',
        17: 'SurchargeRoom',
        18: 'SurchargeFlightTicket',
        19: 'LinkCrossSell',
        20: 'LinkCrossSell',
    }
}

export const ERROR_TYPE_WAREHOUSEMANAGEMENT = [
    'WH_INVALID_REQUEST',
    'WH_INVALID_QTY',
    'WH_INVALID_PLAN_SALE_DATE',
    'WH_INVALID_PLAN_SALE_DATE_DUPLICATED',
    'WH_GR_DUPLICATED_CODE',
    'WH_GR_NOT_FOUND',
    'WH_GR_UPDATE_MISSING_CODE',
    'WH_GR_CODE_INVALID_FORMAT',
    'WH_GR_MISSING_MATERIAL_CODE',
    'WH_GR_MISSING_MATERIAL_NAME',
    'WH_GR_MISSING_SUPPLIER_ID',
    'WH_GR_USE_DATE_FROM_IN_PAST',
    'WH_GR_USE_DATE_TO_IN_PAST',
    'WH_GR_USEDATEFROM_LARGER_THAN_USEDATETO',
    'WH_GR_TOTAL_QTY_MUST_LARGER_THAN_ZERO',
    'WH_PRODUCT_ITEM_IN_TEMPORARY',

]

export const ERROR_TYPE_POINT_CHANGE_HISTORY = [
{
    code: 'SYS_CANCEL_REFUND_INVALID_STATUS',
    description: 'All items status in same activity code must be waiting confirm',

},
{
    code: 'SYS_CANCEL_REFUND_NOT_FOUND_ACTIVITY_CODE',
    description: 'Activity code not found',
},
{
    code: 'SYS_CONFIRM_REFUND_INVALID_STATUS',
    desciprtion: 'All items status in same activity code must be waiting confirm',
},
{
    code: 'SYS_CONFIRM_REFUND_MISSING_ITEM_ACTION_REFUND',
    description: 'Activity code not found item has action is refund',
},
{
    code: 'SYS_EMAIL_NOT_FOUND',
    description: 'Cannot get user info via emails or number of userInfo not matching with number of email request',
},
{
    code: 'SYS_EMAIL_TOPUP_NOT_FOUND',
    desciprtion: 'User topup not found or not exist crmId: {refundItem.ToAccount}'
},
{
    code: 'SYS_CONFIRM_REFUND_NOT_FOUND_ACTIVITY_CODE',
    description: 'Activity code not found'
},
{
    code: 'REFUND_REQUEST_VGID_CANNOT_BE_NULL_OR_EMPTY',
    description: 'VgId cannot be null or empty'
},
{
    code: 'REFUND_REQUEST_ORDER_AMOUNT_CANNOT_MUST_BE_LARGER_THAN_ZERO',
    desciprtion: 'Order amount must be larger than zero'
},
{
    code: 'REFUND_REQUEST_FAILED',
    description: 'Topup point failed'
},
{
    code: 'SPEND_POINT_FAIL',
    desciprtion: 'Spend loyalty point failed'
},
{
    code: 'SYS_REFUND_ITEM_VPT_FAILED',
    desciprtion: 'Refund item in VPT failed'
}
]

export const NATIONALITY = [
    { key: "VN", value: "Việt Nam"},
    { key: "AF", value: "Afghanistan"},
    { key: "AL", value: "Albania"},
    { key: "DZ", value: "Algeria"},
    { key: "AS", value: "American Samoa"},
    { key: "AD", value: "Andorra"},
    { key: "AO", value: "Angola"},
    { key: "AI", value: "Anguilla"},
    { key: "AQ", value: "Antarctica"},
    { key: "AG", value: "Antigua and Barbuda"},
    { key: "AR", value: "Argentina"},
    { key: "AM", value: "Armenia"},
    { key: "AW", value: "Aruba"},
    { key: "AU", value: "Australia"},
    { key: "AT", value: "Austria"},
    { key: "AZ", value: "Azerbaijan"},
    { key: "BS", value: "Bahamas (the)"},
    { key: "BH", value: "Bahrain"},
    { key: "BD", value: "Bangladesh"},
    { key: "BB", value: "Barbados"},
    { key: "BY", value: "Belarus"},
    { key: "BE", value: "Belgium"},
    { key: "BZ", value: "Belize"},
    { key: "BJ", value: "Benin"},
    { key: "BM", value: "Bermuda"},
    { key: "BT", value: "Bhutan"},
    { key: "BO", value: "Bolivia (Plurinational State of)"},
    { key: "BQ", value: "Bonaire, Sint Eustatius and Saba"},
    { key: "BA", value: "Bosnia and Herzegovina"},
    { key: "BW", value: "Botswana"},
    { key: "BV", value: "Bouvet Island"},
    { key: "BR", value: "Brazil"},
    { key: "IO", value: "British Indian Ocean Territory (the)"},
    { key: "BN", value: "Brunei Darussalam"},
    { key: "BG", value: "Bulgaria"},
    { key: "BF", value: "Burkina Faso"},
    { key: "BI", value: "Burundi"},
    { key: "CV", value: "Cabo Verde"},
    { key: "KH", value: "Cambodia"},
    { key: "CM", value: "Cameroon"},
    { key: "CA", value: "Canada"},
    { key: "KY", value: "Cayman Islands (the)"},
    { key: "CF", value: "Central African Republic (the)"},
    { key: "TD", value: "Chad"},
    { key: "CL", value: "Chile"},
    { key: "CN", value: "China"},
    { key: "CX", value: "Christmas Island"},
    { key: "CC", value: "Cocos (Keeling) Islands (the)"},
    { key: "CO", value: "Colombia"},
    { key: "KM", value: "Comoros (the)"},
    { key: "CD", value: "Congo (the Democratic Republic of the)"},
    { key: "CG", value: "Congo (the)"},
    { key: "CK", value: "Cook Islands (the)"},
    { key: "CR", value: "Costa Rica"},
    { key: "HR", value: "Croatia"},
    { key: "CU", value: "Cuba"},
    { key: "CW", value: "Curaçao"},
    { key: "CY", value: "Cyprus"},
    { key: "CZ", value: "Czechia"},
    { key: "CI", value: "Côte d'Ivoire"},
    { key: "DK", value: "Denmark"},
    { key: "DJ", value: "Djibouti"},
    { key: "DM", value: "Dominica"},
    { key: "DO", value: "Dominican Republic (the)"},
    { key: "EC", value: "Ecuador"},
    { key: "EG", value: "Egypt"},
    { key: "SV", value: "El Salvador"},
    { key: "GQ", value: "Equatorial Guinea"},
    { key: "ER", value: "Eritrea"},
    { key: "EE", value: "Estonia"},
    { key: "SZ", value: "Eswatini"},
    { key: "ET", value: "Ethiopia"},
    { key: "FK", value: "Falkland Islands (the) [Malvinas]"},
    { key: "FO", value: "Faroe Islands (the)"},
    { key: "FJ", value: "Fiji"},
    { key: "FI", value: "Finland"},
    { key: "FR", value: "France"},
    { key: "GF", value: "French Guiana"},
    { key: "PF", value: "French Polynesia"},
    { key: "TF", value: "French Southern Territories (the)"},
    { key: "GA", value: "Gabon"},
    { key: "GM", value: "Gambia (the)"},
    { key: "GE", value: "Georgia"},
    { key: "DE", value: "Germany"},
    { key: "GH", value: "Ghana"},
    { key: "GI", value: "Gibraltar"},
    { key: "GR", value: "Greece"},
    { key: "GL", value: "Greenland"},
    { key: "GD", value: "Grenada"},
    { key: "GP", value: "Guadeloupe"},
    { key: "GU", value: "Guam"},
    { key: "GT", value: "Guatemala"},
    { key: "GG", value: "Guernsey"},
    { key: "GN", value: "Guinea"},
    { key: "GW", value: "Guinea-Bissau"},
    { key: "GY", value: "Guyana"},
    { key: "HT", value: "Haiti"},
    { key: "HM", value: "Heard Island and McDonald Islands"},
    { key: "VA", value: "Holy See (the)"},
    { key: "HN", value: "Honduras"},
    { key: "HK", value: "Hong Kong"},
    { key: "HU", value: "Hungary"},
    { key: "IS", value: "Iceland"},
    { key: "IN", value: "India"},
    { key: "ID", value: "Indonesia"},
    { key: "IR", value: "Iran (Islamic Republic of)"},
    { key: "IQ", value: "Iraq"},
    { key: "IE", value: "Ireland"},
    { key: "IM", value: "Isle of Man"},
    { key: "IL", value: "Israel"},
    { key: "IT", value: "Italy"},
    { key: "JM", value: "Jamaica"},
    { key: "JP", value: "Japan"},
    { key: "JE", value: "Jersey"},
    { key: "JO", value: "Jordan"},
    { key: "KZ", value: "Kazakhstan"},
    { key: "KE", value: "Kenya"},
    { key: "KI", value: "Kiribati"},
    { key: "KP", value: "Korea (the Democratic People's Republic of)"},
    { key: "KR", value: "Korea (the Republic of)"},
    { key: "KW", value: "Kuwait"},
    { key: "KG", value: "Kyrgyzstan"},
    { key: "LA", value: "Lao People's Democratic Republic (the)"},
    { key: "LV", value: "Latvia"},
    { key: "LB", value: "Lebanon"},
    { key: "LS", value: "Lesotho"},
    { key: "LR", value: "Liberia"},
    { key: "LY", value: "Libya"},
    { key: "LI", value: "Liechtenstein"},
    { key: "LT", value: "Lithuania"},
    { key: "LU", value: "Luxembourg"},
    { key: "MO", value: "Macao"},
    { key: "MG", value: "Madagascar"},
    { key: "MW", value: "Malawi"},
    { key: "MY", value: "Malaysia"},
    { key: "MV", value: "Maldives"},
    { key: "ML", value: "Mali"},
    { key: "MT", value: "Malta"},
    { key: "MH", value: "Marshall Islands (the)"},
    { key: "MQ", value: "Martinique"},
    { key: "MR", value: "Mauritania"},
    { key: "MU", value: "Mauritius"},
    { key: "YT", value: "Mayotte"},
    { key: "MX", value: "Mexico"},
    { key: "FM", value: "Micronesia (Federated States of)"},
    { key: "MD", value: "Moldova (the Republic of)"},
    { key: "MC", value: "Monaco"},
    { key: "MN", value: "Mongolia"},
    { key: "ME", value: "Montenegro"},
    { key: "MS", value: "Montserrat"},
    { key: "MA", value: "Morocco"},
    { key: "MZ", value: "Mozambique"},
    { key: "MM", value: "Myanmar"},
    { key: "NA", value: "Namibia"},
    { key: "NR", value: "Nauru"},
    { key: "NP", value: "Nepal"},
    { key: "NL", value: "Netherlands (the)"},
    { key: "NC", value: "New Caledonia"},
    { key: "NZ", value: "New Zealand"},
    { key: "NI", value: "Nicaragua"},
    { key: "NE", value: "Niger (the)"},
    { key: "NG", value: "Nigeria"},
    { key: "NU", value: "Niue"},
    { key: "NF", value: "Norfolk Island"},
    { key: "MP", value: "Northern Mariana Islands (the)"},
    { key: "NO", value: "Norway"},
    { key: "OM", value: "Oman"},
    { key: "PK", value: "Pakistan"},
    { key: "PW", value: "Palau"},
    { key: "PS", value: "Palestine, State of"},
    { key: "PA", value: "Panama"},
    { key: "PG", value: "Papua New Guinea"},
    { key: "PY", value: "Paraguay"},
    { key: "PE", value: "Peru"},
    { key: "PH", value: "Philippines (the)"},
    { key: "PN", value: "Pitcairn"},
    { key: "PL", value: "Poland"},
    { key: "PT", value: "Portugal"},
    { key: "PR", value: "Puerto Rico"},
    { key: "QA", value: "Qatar"},
    { key: "MK", value: "Republic of North Macedonia"},
    { key: "RO", value: "Romania"},
    { key: "RU", value: "Russian Federation (the)"},
    { key: "RW", value: "Rwanda"},
    { key: "RE", value: "Réunion"},
    { key: "BL", value: "Saint Barthélemy"},
    { key: "SH", value: "Saint Helena, Ascension and Tristan da Cunha"},
    { key: "KN", value: "Saint Kitts and Nevis"},
    { key: "LC", value: "Saint Lucia"},
    { key: "MF", value: "Saint Martin (French part)"},
    { key: "PM", value: "Saint Pierre and Miquelon"},
    { key: "VC", value: "Saint Vincent and the Grenadines"},
    { key: "WS", value: "Samoa"},
    { key: "SM", value: "San Marino"},
    { key: "ST", value: "Sao Tome and Principe"},
    { key: "SA", value: "Saudi Arabia"},
    { key: "SN", value: "Senegal"},
    { key: "RS", value: "Serbia"},
    { key: "SC", value: "Seychelles"},
    { key: "SL", value: "Sierra Leone"},
    { key: "SG", value: "Singapore"},
    { key: "SX", value: "Sint Maarten (Dutch part)"},
    { key: "SK", value: "Slovakia"},
    { key: "SI", value: "Slovenia"},
    { key: "SB", value: "Solomon Islands"},
    { key: "SO", value: "Somalia"},
    { key: "ZA", value: "South Africa"},
    { key: "GS", value: "South Georgia and the South Sandwich Islands"},
    { key: "SS", value: "South Sudan"},
    { key: "ES", value: "Spain"},
    { key: "LK", value: "Sri Lanka"},
    { key: "SD", value: "Sudan (the)"},
    { key: "SR", value: "Suriname"},
    { key: "SJ", value: "Svalbard and Jan Mayen"},
    { key: "SE", value: "Sweden"},
    { key: "CH", value: "Switzerland"},
    { key: "SY", value: "Syrian Arab Republic"},
    { key: "TW", value: "Taiwan (Province of China)"},
    { key: "TJ", value: "Tajikistan"},
    { key: "TZ", value: "Tanzania, United Republic of"},
    { key: "TH", value: "Thailand"},
    { key: "TL", value: "Timor-Leste"},
    { key: "TG", value: "Togo"},
    { key: "TK", value: "Tokelau"},
    { key: "TO", value: "Tonga"},
    { key: "TT", value: "Trinidad and Tobago"},
    { key: "TN", value: "Tunisia"},
    { key: "TR", value: "Turkey"},
    { key: "TM", value: "Turkmenistan"},
    { key: "TC", value: "Turks and Caicos Islands (the)"},
    { key: "TV", value: "Tuvalu"},
    { key: "UG", value: "Uganda"},
    { key: "UA", value: "Ukraine"},
    { key: "AE", value: "United Arab Emirates (the)"},
    { key: "GB", value: "United Kingdom of Great Britain and Northern Ireland (the)"},
    { key: "UM", value: "United States Minor Outlying Islands (the)"},
    { key: "US", value: "United States of America (the)"},
    { key: "UY", value: "Uruguay"},
    { key: "UZ", value: "Uzbekistan"},
    { key: "VU", value: "Vanuatu"},
    { key: "VE", value: "Venezuela (Bolivarian Republic of)"},
    { key: "VG", value: "Virgin Islands (British)"},
    { key: "VI", value: "Virgin Islands (U.S.)"},
    { key: "WF", value: "Wallis and Futuna"},
    { key: "EH", value: "Western Sahara"},
    { key: "YE", value: "Yemen"},
    { key: "ZM", value: "Zambia"},
    { key: "ZW", value: "Zimbabwe"},
    { key: "AX", value: "Åland Islands"},
];

export const IDENTITYTYPE = [
    {
        key: 0,
        value: "CMT",
           label: "Chứng Minh Thư"
    },
    {
        key: 1,
        value: "Passport",
        label: "Passport"
    },
    {
        key: 2,
        value: "CCCD",
        label: "Căn Cước Công Dân"
    }
];

export const INTEREST_UNIT_TYPE = {
    MONEY: 1,
    PERCENT: 2
}

export const DaysOfTheWeek = [
    {
      id: "1",
      text: "Chủ nhật",
    },
    {
      id: "5",
      text: "Thứ 5",
    },
    {
      id: "2",
      text: "Thứ 2",
    },
    {
      id: "6",
      text: "Thứ 6",
    },
    {
      id: "3",
      text: "Thứ 3",
    },
    {
      id: "7",
      text: "Thứ 7",
    },
    {
      id: "4",
      text: "Thứ 4",
    },
  ];

export const PACKAGE_RATE_CHANNEL = {
    ALL: {
        ALL: { value: "", label: 'Tất cả'},
    },
    OTHER: {
        BookingVinpearl: { value: "VPT", label: 'Booking Vinpearl'},
        Vinpearl: { value: "VP", label: 'Vinpearl'},
        MyVinPearl: { value: "MOBILE", label: 'My VinPearl'},
    }
}

export const PACKAGE_RATE_OBJECT = {
    ALL: {
        ALL: { value: "", label: 'Tất cả'},
    },
    OTHER: {
        NON: { value: "NON", label: 'Non'},
        MEMBER: { value: 'MEMBER', label: 'Member' },
        Pearl: { value: "PEARL", label: 'Gold (Pearl)'},
        AmPearl: { value: "AMBASSADOR_PEARL", label: 'Platinum (AmPearl)'},
        VipPearl: { value: "PEARL_CLUB", label: 'Diamond (VipPearl)'},
    }
}

export const PACKAGE_RATE_MARKUP_TYPE = {
    CASH: { value: 0, label: 'Theo tiền'},
    PERCENTAGE: { value: 1, label: 'Theo %'}
}

export const PACKAGE_RATE_MARKUP_MULTIPLE_ROOM = {
    ROOM: { value: 0, label: 'Number of room'},
    BEDROOM: { value: 1, label: 'Number of bed room'}
}

export const PACKAGE_RATE_PRODUCT_TYPE = {
    RATEPLAN: { value: 0, label: 'Rate plan'},
    BOOKABLE: { value: 1, label: 'Bookable'},
    RATECODE: { value: 2, label: 'Rate code'}
}

export const PACKAGE_RATE_DISPLAY_SALE_TYPE = {
    PACKAGERATE: { value: 1, label: 'PackageRate'},
    CROSSSALE: { value: 2, label: 'CrossSale'},
    UPSELL: { value: 3, label: 'Upsell'},
}

export const CHECKOUT_PMS = {
    NO: 0,
    YES: 1,
    ALTER: 2
}

export const COLLABORATOR_REPORT = {
    STATUS : [
        {value: 1, text: 'Failed'},
        {value: 2, text: 'Success'},
        {value: 5, text: 'PartiallyCancelled'},
        {value: 6, text: 'Cancelled'},
        {value: 7, text: 'PartiallyRefunded'},
        {value: 8, text: 'Refunded'},
        {value: 9, text: 'Waiting'},
    ]
}

export const typeReportSku = [
    {
        text: 'Ngày bán',
        value: false
    },
    {
        text: 'Ngày Check-in',
        value: true
    }
]

export const typeReportBundle = [
    {
        text: 'Ngày bán',
        value: 'saleDate'
    },
    {
        text: 'Ngày Check-in',
        value: 'checkIn'
    },
    {
        text: 'Ngày Check-out',
        value: 'checkOut'
    }
]

export const screenTypeEnum = [
    {
        text: 'Màn hình Welcome',
        value: 1
    },
    // {
    //     text: 'Trang chủ',
    //     value: 2
    // },
    {
        text: 'Du lịch theo chủ đề - Trang chủ app',
        value: 3
    }
]

export const CACHE_HOTEL_SEARCH_TYPE = [
    {
        value: 1,
        lable: 'Hotel Info',
    },
    {
        value: 2,
        lable: 'Hotel Tag',
    },
    {
        value: 3,
        lable: 'Rate Filter Tag',
    },
    {
        value: 4,
        lable: 'Markup Config',
    },
    {
        value: 5,
        lable: 'Promotion Config',
    },
    {
        value: 6,
        lable: 'Phs Config',
    },
    {
        value: 7,
        lable: 'Pay At Hotel',
    },
    {
        value: 8,
        lable: 'Amenity Config',
    },
    {
        value: 9,
        lable: 'Package Rate',
    },
    {
        value: 10,
        lable: 'Rate Compare Config',
    },
    {
        value: 0,
        lable: 'All',
    },
]

export const ENUM_SOURCE_FLIGHT = {
    DATA_COM: 'dtc',
    VIET_JET: 'vj'
};

export const TAG_GROUP_SITE_TYPE = {
    PRODUCT_LISTING: 1,
    MICROSITE: 2
}

export const ENUM_SUPPLIER_SALE_DATE_TYPE = {
    NONE: 'NONE',
    MULTIPLE: 'MULTIPLE',
    RANGE:'RANGE'
}

export const DAY_OF_WEEK = [
    { value: 0, name: "Sunday", label: `Chủ nhật` },
    { value: 1, name: "Monday", label: `Thứ 2` },
    { value: 2, name: "Tuesday", label: `Thứ 3` },
    { value: 3, name: "Wednesday", label: `Thứ 4` },
    { value: 4, name: "Thursday", label: `Thứ 5` },
    { value: 5, name: "Friday", label: `Thứ 6` },
    { value: 6, name: "Saturday", label: `Thứ 7` },
]
